export default {
  data() {
    return {
      info: null,
    };
  },
  methods: {
    setInfo(info) {
      this.info = info;
    },
    closeCheckout() {
      this.showCloseCheckoutModal();
    },
  },
  async created() {
    const localCheckout = await localStorage.getItem('checkout');

    if (localCheckout) {
      const data = JSON.parse(localCheckout);

      this.$store.commit('SET_SHIPPING_OPTIONS', data.shippingOptions);
      this.$store.commit('SET_PAYMENT_OPTIONS', data.paymentOptions);
      this.$store.commit('SET_PAYMENT_CONFIGS', data.paymentConfigs);

      this.$store.dispatch('SET_CHECKOUT', data.checkout);
      this.$store.dispatch('SET_TMP_ORDER', data.tmpOrder);
      this.$store.dispatch('SET_CHECKOUT_STEP', 6);
    } else if (!this.cart || this.cart && this.cart.quantity <= 0) {
      this.$router.push(this.i18nLink('cart'));
    } else if (this.checkout.paymentOption) {
      this.$store.dispatch('SET_CHECKOUT_STEP', 6);
    } else if (this.user) {
      let checkout = this.checkout;
      checkout.authType = 'user';

      this.$store.dispatch('SET_CHECKOUT_STEP', this.checkout.orderAsGuest ? 3 : 2);

      if (this.checkout.orderAsGuest) {
        this.$store.dispatch('INIT_SHIPPING_OPTIONS', {
          order_id: this.tmpOrder.id,
        });

        this.$store.dispatch('SET_CHECKOUT_STEP', 3);
      }

      this.$store.dispatch('SET_CHECKOUT', checkout);
    } else {
      this.$store.dispatch('SET_CHECKOUT_STEP',
          this.checkout.authType === 'registration'
          || this.checkout.orderAsGuest ? 2 : 1);
    }
  },
};
